import React from 'react';
import propTypes from 'prop-types';
import {
  DISCLAIMER_ICONS,
  DISCLAIMER_COLORS
} from 'helpers/factory/carrierFactory';
import { Info, TriangleAlert } from 'lucide-react';
import BadgeWithIcon from 'tailwind-components/BadgeWithIcon/BadgeWithIcon';
import { sanitizeDirtyHTML } from 'helpers/strings';
import { cn } from 'lib/utils';

const COLOR_CLASS_MAP = {
  [DISCLAIMER_COLORS.BLUE]:
    'text-primary-darkened bg-primary-darkened/10 border-primary-darkened',
  [DISCLAIMER_COLORS.RED]:
    'text-semantic-danger bg-semantic-danger/10 border-semantic-danger',
  [DISCLAIMER_COLORS.GREEN]:
    'text-secondary-darkened bg-secondary-darkened/10 border-secondary-darkened',
  [DISCLAIMER_COLORS.YELLOW]: 'text-pending bg-pending/10 border-pending',
  [DISCLAIMER_COLORS.GRAY]: 'text-grey bg-grey/10 border-grey'
};

function getColorClass(color) {
  return COLOR_CLASS_MAP[color] || COLOR_CLASS_MAP[DISCLAIMER_COLORS.GRAY];
}

function getIconComponent(icon) {
  if (icon === DISCLAIMER_ICONS.WARNING) return TriangleAlert;
  return Info;
}

export default function CarrierDisclaimer({
  disclaimer,
  className,
  htmlClassName
}) {
  const { text, color, icon } = disclaimer;
  if (!text) return null;

  const Icon = getIconComponent(icon);
  const colorClassName = getColorClass(color);

  return (
    <BadgeWithIcon
      icon={
        <Icon className='size-5 shrink-0 text-inherit' size={20} aria-hidden />
      }
      className={cn(colorClassName, className)}
    >
      <div
        className={cn(
          'text-sm leading-snug text-inherit [&_a]:font-semibold [&_a]:text-inherit! [&_a]:no-underline hover:[&_a]:underline',
          htmlClassName
        )}
        dangerouslySetInnerHTML={sanitizeDirtyHTML(text)}
      />
    </BadgeWithIcon>
  );
}

CarrierDisclaimer.propTypes = {
  disclaimer: propTypes.object.isRequired,
  className: propTypes.string,
  htmlClassName: propTypes.string
};
